import React from 'react';

const ProfileIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9149 11.6668C15.95 11.6668 16.789 12.5058 16.789 13.5409V14.3062C16.789 14.7841 16.6396 15.2499 16.3618 15.6386C15.0735 17.4413 12.97 18.3344 10.1198 18.3344C7.26896 18.3344 5.16649 17.441 3.88135 15.6373C3.60472 15.2491 3.45605 14.7842 3.45605 14.3075V13.5409C3.45605 12.5058 4.2951 11.6668 5.33011 11.6668H14.9149ZM10.1198 1.67072C12.421 1.67072 14.2865 3.5362 14.2865 5.83738C14.2865 8.13857 12.421 10.0041 10.1198 10.0041C7.81858 10.0041 5.9531 8.13857 5.9531 5.83738C5.9531 3.5362 7.81858 1.67072 10.1198 1.67072Z"
      fill="#27B0E0"
    />
  </svg>
);

export default ProfileIcon;
